import { Primitive } from '../Primitive';
import { Type } from '../Type';
import { Point3D } from './Point3D';
export class Sphere extends Primitive {
    constructor(center, radius) {
        super(Type.Sphere);
        let centerValue;
        switch (true) {
            case center instanceof Point3D:
                centerValue = center;
                break;
            case Array.isArray(center):
                center = center;
                centerValue = new Point3D(center[0], center[1], center[2]);
                break;
            default:
                center = center;
                centerValue = new Point3D(center.x, center.y, center.z);
        }
        this.center = centerValue;
        this.radius = radius;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU3BoZXJlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vc3JjL2xpYi90eXBlcy9nZW9tZXRyeV8zZC9TcGhlcmUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLFNBQVMsRUFBRSxNQUFNLGNBQWMsQ0FBQTtBQUN4QyxPQUFPLEVBQUUsSUFBSSxFQUFFLE1BQU0sU0FBUyxDQUFBO0FBRTlCLE9BQU8sRUFBRSxPQUFPLEVBQUUsTUFBTSxXQUFXLENBQUE7QUFFbkMsTUFBTSxPQUFPLE1BQU8sU0FBUSxTQUFTO0lBSW5DLFlBQ0UsTUFHNEIsRUFDNUIsTUFBYztRQUVkLEtBQUssQ0FBQyxJQUFJLENBQUMsTUFBTSxDQUFDLENBQUE7UUFFbEIsSUFBSSxXQUFvQixDQUFBO1FBQ3hCLFFBQVEsSUFBSSxFQUFFLENBQUM7WUFDYixLQUFLLE1BQU0sWUFBWSxPQUFPO2dCQUM1QixXQUFXLEdBQUcsTUFBaUIsQ0FBQTtnQkFDL0IsTUFBSztZQUNQLEtBQUssS0FBSyxDQUFDLE9BQU8sQ0FBQyxNQUFNLENBQUM7Z0JBQ3hCLE1BQU0sR0FBRyxNQUFrQyxDQUFBO2dCQUMzQyxXQUFXLEdBQUcsSUFBSSxPQUFPLENBQUMsTUFBTSxDQUFDLENBQUMsQ0FBQyxFQUFFLE1BQU0sQ0FBQyxDQUFDLENBQUMsRUFBRSxNQUFNLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQTtnQkFDMUQsTUFBSztZQUNQO2dCQUNFLE1BQU0sR0FBRyxNQUE2QyxDQUFBO2dCQUN0RCxXQUFXLEdBQUcsSUFBSSxPQUFPLENBQUMsTUFBTSxDQUFDLENBQUMsRUFBRSxNQUFNLENBQUMsQ0FBQyxFQUFFLE1BQU0sQ0FBQyxDQUFDLENBQUMsQ0FBQTtRQUMzRCxDQUFDO1FBRUQsSUFBSSxDQUFDLE1BQU0sR0FBRyxXQUFXLENBQUE7UUFDekIsSUFBSSxDQUFDLE1BQU0sR0FBRyxNQUFNLENBQUE7SUFDdEIsQ0FBQztDQUNGIn0=